var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v("\r\n1. Load Per Exam\r\n2. Load Per Course\r\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }